import { Component, OnInit } from '@angular/core';
import { WallService } from '../../services/wall.service';

type concernType = Array<{idPost: string, idContact: string, name: string, surname: string, nick: string, state: number, profileImage: string}>;


@Component({
  selector: 'app-wall',
  templateUrl: './wall.component.html',
  styleUrls: ['./wall.component.css']
})
export class WallComponent implements OnInit {
  day: number;
  month: number;
  year: number;
  firstCalendarDayNumber: number;
  firstCalendarDay: number;
  lastCalendarDay: number;
  weeksCount: any;
  daysCount = Array(7);
  isAll: boolean = true;
  fromDate: string;
  toDate: string;

  months = Array("Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec");
  
  isEdited: boolean = false;
  selecedPost: number = -1;
  editedPost = {
    "id": "",
    "idUser": localStorage.getItem("idUser"),
    "textPost": "",
    "place": "",
    "settings": 0, 
    "postDate": null,
    "postImage": "",
  }
  editedConcerns: concernType = [];
  editedConcernsChanges: concernType = [];
  
  newPost = { 
    postImage: "",
    textPost: "",
    place: "",
    settings: 0,
    postDate: new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + (new Date().getDate())).slice(-2) + "T" + ("0" + new Date().toLocaleTimeString().slice(0,-3)).slice(-5)
  };

  constructor(private wallService: WallService) {  }

  ngOnInit() {
    this.getActualDate();
    this.wallService.getPosts();
    this.wallService.getContacts();
    this.getCalendar();
  }

  getDate(){
    let date = new Date(this.year, this.month, 1).getDay();
  }

  getActualDate(){
    this.day = new Date().getDate();
    this.month = new Date().getMonth();
    this.year = new Date().getFullYear();   
  }

  getInitValue(){
    this.wallService.fromPost = 0;
    this.wallService.postCount = 20;
  }

  getPreviousMonth(){
    this.isAll = false;
    this.toDate = this.year + "-" + ("0" + (this.month + 1)).slice(-2) + "-01 00:00";
    
    this.month--;
    if(this.month < 0) {
      this.month = 11;
      this.year--;
    }
    this.fromDate = this.year + "-" + ("0" + (this.month + 1)).slice(-2) + "-01 00:00";
    this.getInitValue();
    this.wallService.getMonthPosts(this.fromDate,this.toDate);
    this.getCalendar();
  }
  getNextMonth(){
    this.isAll = false;
    this.month++;
    if(this.month > 11) {
      this.month = 0;
      this.year++;
    }
    let nextMonth = this.month+1;
    let nextYear = this.year;
    this.fromDate = this.year + "-" + ("0" + (this.month + 1)).slice(-2) + "-01 00:00";
    
    if(nextMonth > 11) {
      nextMonth = 0;
      nextYear++;
    }

    this.toDate = nextYear + "-" + ("0" + (nextMonth + 1)).slice(-2) + "-01 00:00";
    
    this.getInitValue();
    this.wallService.getMonthPosts(this.fromDate,this.toDate);
    this.getCalendar();
  }

  getMonthPosts(){
    this.isAll = false;
    this.month--;
    this.getNextMonth();
  }
  
  getCalendar(){
    this.getCalendarPosts();
    this.wallService.days = [];
    
    if(new Date(this.year, this.month, 1).getDay() != 0){
      
    }
    
    for(let i = new Date(this.year, this.month, 0).getDate()-new Date(this.year, this.month, 0).getDay()+1; i <= new Date(this.year, this.month, 0).getDate(); i++){
      let day = {
        "day": i,
        "state": 0,
        "postsCount": 0,
        "postText": ""
      }
      this.wallService.days.push(day);
    }

    for(let i = 1; i <= new Date(this.year, this.month+1, 0).getDate(); i++){
      let day = {
        "day": i,
        "state": 1,
        "postsCount": 0,
        "postText": ""
      }
      this.wallService.days.push(day);
    }

    let lastDayOfMonth = new Date(this.year, this.month+1, 0).getDay();
    if(lastDayOfMonth == 0) lastDayOfMonth = 7;

    for(let i = 1; i <= 7 - lastDayOfMonth; i++){
      let day = {
        "day": i,
        "state": 0,
        "postsCount": 0,
        "postText": ""
      }
      this.wallService.days.push(day);
    }
    if(this.wallService.days.length == 42){
      this.weeksCount = Array(6);
    }
    else{
      this.weeksCount = Array(5);
    }

  }

  getCalendarPosts(){
    let fromDate = this.year + "-" + ("0" + (this.month + 1)).slice(-2) + "-01 00:00";
    let toDate = this.year + "-" + ("0" + (this.month + 2)).slice(-2) + "-01 00:00";
    if((this.month+2) > 12){
      toDate = this.year+1 + "-01-01 00:00";
    }
    this.wallService.getDayPosts(fromDate,toDate);
  }

  getDayPosts(day){
    this.getInitValue();
    let fromDate = this.year + "-" + ("0" + (this.month + 1)).slice(-2) + "-" + ("0" + day).slice(-2) + " 00:00";
    let toDate = this.year + "-" + ("0" + (this.month + 1)).slice(-2) + "-" + ("0" + day).slice(-2) + " 23:59";
    this.wallService.getMonthPosts(fromDate,toDate);
  }

  addPost(){
    if(this.wallService.addPost(this.newPost) == true){
      this.newPost.textPost = "";
      this.newPost.postImage = "";
      this.newPost.place = "";
      this.newPost.postDate = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + (new Date().getDate() + 1)).slice(-2) + "T" + ("0" + new Date().toLocaleTimeString().slice(0,-3)).slice(-5);
    }
  }

  removePost(i, id){
    this.wallService.removePost(i, id);
    
  }

  selectPost(i){
    this.selecedPost = i;

    this.editedPost.id = this.wallService.posts[i].id;
    this.editedPost.textPost = this.wallService.posts[i].textPost;
    this.editedPost.place = this.wallService.posts[i].place;
    this.editedPost.settings = this.wallService.posts[i].settings;
    this.editedPost.postDate = this.wallService.posts[i].postDate;
    this.editedPost.postDate = this.editedPost.postDate.replace(' ','T');
    this.editedPost.postImage = this.wallService.posts[i].postImage;

    this.editedConcerns = [];
    this.editedConcernsChanges = [];
    for(let j = 0; j < this.wallService.posts[i].people.length; j++){
      let concernParams = {
        idContact: this.wallService.posts[i].people[j].idContact,
        idPost: this.wallService.posts[i].people[j].idPost,
        name: this.wallService.posts[i].people[j].name,
        surname: this.wallService.posts[i].people[j].surname,
        nick: this.wallService.posts[i].people[j].nick,
        profileImage: this.wallService.posts[i].people[j].profileImage,
        state: 0
      }
      this.editedConcernsChanges.push(concernParams);
      this.editedConcerns.push(concernParams);
    }

  }

  updatePost(){
    this.wallService.updatePost(this.editedPost,this.editedConcernsChanges,this.selecedPost);
  }

  addContactToPost(contactID){
    this.wallService.addtoConcern(contactID);
  }

  deleteConcern(contactID){
    this.wallService.deleteConcern(contactID);
  }

  addContactToEditedPost(contactID){
    let isAdded = false;
    let concern = {
      "idPost": this.editedPost.id,
      "idContact": "",
      "name": "",
      "surname": "",
      "nick": "",
      "profileImage": "",
      "state": 1
    }

    for(let i = 0; i < this.editedConcerns.length; i++){
      if(contactID == this.editedConcerns[i].idContact) isAdded = true;
    }

    for(let i = 0; i < this.editedConcernsChanges.length; i++){
      if(contactID == this.editedConcernsChanges[i].idContact && isAdded == false){
        isAdded = true;
        this.editedConcernsChanges[i].state = this.editedConcernsChanges[i].state + 1;
        if(this.editedConcernsChanges[i].state == 0){
          this.editedConcerns.push(this.editedConcernsChanges[i]); 
        }
      } 
    }

    if(isAdded == false && contactID != ""){
      for(let i = 0; i < this.wallService.mycontacts.length; i++){
        if(contactID == this.wallService.mycontacts[i].id){
          concern.idContact = contactID;
          concern.name = this.wallService.mycontacts[i].name;
          concern.surname = this.wallService.mycontacts[i].surname;
          concern.nick = this.wallService.mycontacts[i].nick;
          concern.profileImage = this.wallService.mycontacts[i].profileImage;
          this.editedConcerns.push(concern);
          this.editedConcernsChanges.push(concern);
          break;
        }
      }    
    }
  }

  deleteFromEditedPost(contactID){  
    for(let i = 0; i < this.editedConcernsChanges.length; i++){
      if(contactID == this.editedConcernsChanges[i].idContact){
        this.editedConcernsChanges[i].state = this.editedConcernsChanges[i].state -1;
        break;
      }
    }
    for(let i = 0; i < this.editedConcerns.length; i++){
      if(contactID == this.editedConcerns[i].idContact){
        this.editedConcerns.splice(i,1);
      }
    }
  }

  morePosts(){
    this.wallService.fromPost += this.wallService.postCount;
    if(this.isAll == true){
      this.wallService.getPosts();
    }
    else{
      this.wallService.getMonthPosts(this.fromDate,this.toDate);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/wall/wall.component.ts